export let Field;

(function (Field) {
  Field["RealName"] = "realName";
  Field["Login"] = "login";
  Field["Email"] = "email";
  Field["Password"] = "password";
  Field["SubscribeToNewsletter"] = "subscribeToNewsletter";
  Field["AgreeRules"] = "agreeRules";
})(Field || (Field = {}));